// extracted by mini-css-extract-plugin
module.exports = {"CreateStoreForm":"CreateStoreForm_CreateStoreForm__1WJ4d","CardContent":"CreateStoreForm_CardContent__4Rk4P"};